<script>
import Button from './Button.svelte';
export let disabled = false;
export let loading = false;
export let clickEvent;

</script>

<Button alternate="{false}" narrow disabled="{disabled}" clickEvent="{() => clickEvent()}">

	{#if loading}
	<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"width="26px" height="26px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
		<circle cx="50" cy="50" fill="none" stroke="#FFF" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
		</circle>
	</svg>
	{:else}
		<slot>Next</slot>
	{/if}

</Button>

<style lang="scss">

svg {
	animation: spin 1s linear infinite;
}

@-moz-keyframes spin { 100% { -moz-transform: rotate(360deg); } }
@-webkit-keyframes spin { 100% { -webkit-transform: rotate(360deg); } }
@keyframes spin { 100% { -webkit-transform: rotate(360deg); transform:rotate(360deg); } }

</style>